import * as React from "react";
import areEqual from "fbjs/lib/areEqual";

import { Col } from "./Colgroup.styles";

interface ColgroupProps {
    columnWidth: number[];
    verticalLines?: number[];
}

export const Colgroup = React.memo(
    (props: ColgroupProps): JSX.Element => (
        <colgroup>
            {props.columnWidth.map((width, index) => (
                <Col bordered={(props.verticalLines ?? []).includes(index + 1)} key={`column_${index}`} width={width} />
            ))}
        </colgroup>
    ),
    (prev, next) => areEqual(prev.columnWidth, next.columnWidth) && areEqual(prev.verticalLines, next.verticalLines)
);
Colgroup.displayName = "Colgroup";
